import React from "react";
import { useSelector } from "react-redux";

import one from '../../assest/bo.jpg';
import two from '../../assest/boone.jpg';
import three from '../../assest/botwo.jpg';

// Images
import excavatorImg from '../../assest/heavy.jpg';
import FaqSection from "../../components/about/FAQ";
import ServicesCard from "../../components/home/ServicesCard";

const translations = {
    gb: {
        heading: "Bulldozers",
        buttonText: "Explore Bulldozer Services",
        introText: "Our bulldozers are built for unmatched power and durability in the most demanding earthmoving tasks. Ideal for construction, mining, and land clearing projects, our machines deliver exceptional pushing force, stability, and reliability to handle any job with efficiency.",
        categoriesTitle: "Our Bulldozer Models",
        featuredTitle: "Featured Bulldozers",
        featuredDescription: "Bulldozers are powerful tracked heavy equipment with a substantial metal blade used to push large quantities of soil, sand, rubble, or other materials during construction or conversion work.",
        whyChooseTitle: "Why Choose Our Bulldozers?",
        features: [
            {
                title: "Unmatched Power",
                text: "Our bulldozers feature high-torque engines and reinforced blades for maximum earthmoving capacity."
            },
            {
                title: "Expert Support",
                text: "We provide technical guidance and on-site assistance to ensure optimal machine performance."
            },
            {
                title: "Cost-Effective Solutions",
                text: "Competitive pricing with heavy-duty machines built to last in tough conditions."
            }
        ],
        excavatorList: [
            {
                name: "Compact Bulldozer",
                specs: "Perfect for small to medium-scale grading and earthmoving in confined spaces.",
                description: "Compact bulldozers excel in residential construction, landscaping, and small-scale earthmoving projects with their agility and precision.",
            },
            {
                name: "Standard Bulldozer",
                specs: "Versatile machine for medium to large-scale construction and site preparation.",
                description: "Standard bulldozers provide robust pushing power for grading, land clearing, and material handling on diverse job sites.",
            },
            {
                name: "Large Bulldozer",
                specs: "Heavy-duty machine for large-scale mining and major earthmoving operations.",
                description: "Large bulldozers are engineered for major construction and mining projects, delivering unmatched power for moving massive amounts of material.",
            }
        ],
        specsLabel: "Specs:"
    },
    sa: {
        heading: "الجرارات",
        buttonText: "استكشف خدمات الجرارات",
        introText: "تم بناء جراراتنا لتقديم قوة ومتانة لا مثيل لها في أكثر مهام نقل التربة صعوبة. مثالية لمشاريع البناء والتعدين وتطهير الأراضي، توفر آلاتنا قوة دفع استثنائية واستقرارًا وموثوقية للتعامل مع أي عمل بكفاءة.",
        categoriesTitle: "موديلات الجرارات لدينا",
        featuredTitle: "الجرارات المميزة",
        featuredDescription: "الجرارات هي معدات ثقيلة مزودة بشفرات معدنية كبيرة تستخدم لدفع كميات كبيرة من التربة أو الرمل أو الأنقاض أو غيرها من المواد أثناء أعمال البناء أو التحويل.",
        whyChooseTitle: "لماذا تختار جراراتنا؟",
        features: [
            {
                title: "قوة لا مثيل لها",
                text: "جراراتنا مزودة بمحركات عزم عالي وشفرات معززة لأقصى قدرة على نقل التربة."
            },
            {
                title: "دعم الخبراء",
                text: "نقدم التوجيه الفني والمساعدة الميدانية لضمان الأداء الأمثل للآلة."
            },
            {
                title: "حلول فعالة من حيث التكلفة",
                text: "أسعار تنافسية مع آلات ثقيلة مصممة لتدوم في الظروف القاسية."
            }
        ],
        excavatorList: [
            {
                name: "جرار مضغوط",
                specs: "مثالي لأعمال التسوية ونقل التربة على نطاق صغير إلى متوسط في المساحات الضيقة.",
                description: "تتفوق الجرارات المضغوطة في أعمال البناء السكني وتنسيق المواقع ومشاريع نقل التربة الصغيرة بفضل خفة حركتها ودقتها.",
            },
            {
                name: "جرار قياسي",
                specs: "آلة متعددة الاستخدامات لأعمال البناء على نطاق متوسط إلى كبير وإعداد المواقع.",
                description: "توفر الجرارات القياسية قوة دفع قوية لأعمال التسوية وتطهير الأراضي ومعالجة المواد في مواقع العمل المتنوعة.",
            },
            {
                name: "جرار كبير",
                specs: "آلة ثقيلة لمشاريع التعدين الكبيرة وعمليات نقل التربة الرئيسية.",
                description: "تم تصميم الجرارات الكبيرة لمشاريع البناء والتعدين الكبرى، حيث توفر قوة لا مثيل لها لتحريك كميات هائلة من المواد.",
            }
        ],
        specsLabel: "المواصفات:"
    },
    fr: {
        heading: "Bulldozers",
        buttonText: "Explorer les services de bulldozers",
        introText: "Nos bulldozers sont conçus pour une puissance et une durabilité inégalées dans les travaux de terrassement les plus exigeants. Idéaux pour les projets de construction, d'exploitation minière et de défrichement, nos machines offrent une force de poussée exceptionnelle, une stabilité et une fiabilité pour accomplir tout travail avec efficacité.",
        categoriesTitle: "Nos modèles de bulldozers",
        featuredTitle: "Bulldozers en vedette",
        featuredDescription: "Les bulldozers sont des équipements lourds à chenilles dotés d'une lame métallique importante utilisée pour pousser de grandes quantités de terre, de sable, de gravats ou d'autres matériaux pendant les travaux de construction ou de conversion.",
        whyChooseTitle: "Pourquoi choisir nos bulldozers?",
        features: [
            {
                title: "Puissance inégalée",
                text: "Nos bulldozers sont équipés de moteurs à couple élevé et de lames renforcées pour une capacité maximale de terrassement."
            },
            {
                title: "Soutien expert",
                text: "Nous offrons des conseils techniques et une assistance sur site pour garantir des performances optimales des machines."
            },
            {
                title: "Solutions économiques",
                text: "Des prix compétitifs avec des machines robustes conçues pour durer dans des conditions difficiles."
            }
        ],
        excavatorList: [
            {
                name: "Bulldozer compact",
                specs: "Parfait pour le nivellement et le terrassement à petite et moyenne échelle dans des espaces confinés.",
                description: "Les bulldozers compacts excellent dans la construction résidentielle, l'aménagement paysager et les petits projets de terrassement grâce à leur agilité et leur précision.",
            },
            {
                name: "Bulldozer standard",
                specs: "Machine polyvalente pour la construction à moyenne et grande échelle et la préparation de sites.",
                description: "Les bulldozers standards offrent une puissance de poussée robuste pour le nivellement, le défrichement et la manutention de matériaux sur divers chantiers.",
            },
            {
                name: "Grand bulldozer",
                specs: "Machine lourde pour l'exploitation minière à grande échelle et les grandes opérations de terrassement.",
                description: "Les grands bulldozers sont conçus pour les grands projets de construction et miniers, offrant une puissance inégalée pour déplacer des quantités massives de matériaux.",
            }
        ],
        specsLabel: "Spécifications:"
    },
    de: {
        heading: "Bulldozer",
        buttonText: "Bulldozer-Dienstleistungen erkunden",
        introText: "Unsere Bulldozer sind für unübertroffene Kraft und Haltbarkeit bei den anspruchsvollsten Erdbewegungsarbeiten gebaut. Ideal für Bau-, Bergbau- und Landrodungsprojekte bieten unsere Maschinen außergewöhnliche Schubkraft, Stabilität und Zuverlässigkeit, um jede Aufgabe effizient zu bewältigen.",
        categoriesTitle: "Unsere Bulldozer-Modelle",
        featuredTitle: "Vorgestellte Bulldozer",
        featuredDescription: "Bulldozer sind kraftvolle Kettenfahrzeuge mit einer massiven Metallschaufel, die zum Schieben großer Mengen von Erde, Sand, Schutt oder anderen Materialien bei Bau- oder Umwandlungsarbeiten eingesetzt wird.",
        whyChooseTitle: "Warum unsere Bulldozer wählen?",
        features: [
            {
                title: "Unübertroffene Kraft",
                text: "Unsere Bulldozer verfügen über hochdrehmomentstarke Motoren und verstärkte Schaufeln für maximale Erdbewegungskapazität."
            },
            {
                title: "Fachkundige Unterstützung",
                text: "Wir bieten technische Beratung und Vor-Ort-Unterstützung, um eine optimale Maschinenleistung zu gewährleisten."
            },
            {
                title: "Kosteneffiziente Lösungen",
                text: "Wettbewerbsfähige Preise mit robusten Maschinen, die für den Einsatz unter harten Bedingungen gebaut sind."
            }
        ],
        excavatorList: [
            {
                name: "Kompakter Bulldozer",
                specs: "Perfekt für kleine bis mittlere Planierungs- und Erdbewegungsarbeiten in beengten Räumen.",
                description: "Kompakte Bulldozer zeichnen sich im Wohnungsbau, in der Landschaftsgestaltung und bei kleinen Erdbewegungsprojekten durch ihre Wendigkeit und Präzision aus.",
            },
            {
                name: "Standard Bulldozer",
                specs: "Vielseitige Maschine für mittlere bis große Bauvorhaben und Baustellenvorbereitung.",
                description: "Standard-Bulldozer bieten eine robuste Schubkraft für Planierungsarbeiten, Landrodung und Materialhandling auf verschiedenen Baustellen.",
            },
            {
                name: "Großer Bulldozer",
                specs: "Schwere Maschine für großangelegten Bergbau und große Erdbewegungsarbeiten.",
                description: "Große Bulldozer sind für große Bau- und Bergbauprojekte konzipiert und bieten unübertroffene Kraft, um massive Materialmengen zu bewegen.",
            }
        ],
        specsLabel: "Spezifikationen:"
    }
};

const imageStyle = {
    height: '250px',
    width: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
};

const Bulldozers = () => {
    const { language } = useSelector((state) => state.language);
    const t = translations[language] || translations.gb;

    return (
        <div>
            {/* Introduction Text */}
            <section
                style={{
                    background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)',
                    padding: '20px',
                }}
            >
                <h1 className="text-center mb-4 mt-5">{t.heading}</h1>
                <p
                    className="text-center mb-5 mx-auto"
                    style={{ fontSize: '1.1rem', maxWidth: '70%' }}
                >
                    {t.introText}
                </p>
            </section>

            {/* Excavator Models */}
            <section className="container py-5">
                <h2 className="text-center mb-4">{t.categoriesTitle}</h2>
                <div className="row text-center">
                    {t.excavatorList.map((item, idx) => (
                        <div className="col-md-4 mb-4" key={idx}>
                            <img src={[one, two, three][idx]} alt={item.name} style={imageStyle} />
                            <h5 className="mt-3">{item.name}</h5>
                            <p><strong>{t.specsLabel}</strong> {item.specs}</p>
                            <p>{item.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Featured Excavators */}
            <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <h2 className="text-center mb-4">{t.featuredTitle}</h2>
                    <p className="text-center mb-4">{t.featuredDescription}</p>

                    <ul className="list-group">
                        {t.excavatorList.map((item, idx) => (
                            <li key={idx} className="list-group-item mb-3">
                                <div className="row">
                                    <div className="col-md-3">
                                        <img src={[one, two, three][idx]} alt={item.name} style={imageStyle} />
                                    </div>
                                    <div className="col-md-9">
                                        <h5>{item.name}</h5>
                                        <p>{item.description}</p>
                                        <p><strong>{t.specsLabel}</strong> {item.specs}</p>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <ServicesCard showHeading={false} showParagraph={false} />
            <FaqSection />
        </div>
    );
};

export default Bulldozers;